// extracted by mini-css-extract-plugin
export default {"modalOverlay":"WC-z","modalContent":"XC-z","header":"YC-z","close":"ZC-z"};